import React from 'react';

import { Button, Icon } from '@components';

import { CalendarIntegrationContentProps } from './types';

const CalendarIntegrationContent: React.FC<CalendarIntegrationContentProps> = ({
  isConnected,
  onViewDetails,
  handleConnection,
  isLoading = false
}) => (
  <div className="w-full rounded-2xl border border-grey30 p-4 md:w-1/2 xl:w-1/3 2xl:w-1/4">
    <div className="mb-3 flex items-center justify-between">
      <div className="flex size-12.5 shrink-0 items-center justify-center rounded-lg bg-cofeeGreyNeutral4">
        <Icon name="google-calendar" size="24" className="text-greyText1" />
      </div>

      {isConnected && (
        <div className="shrink-0">
          <span className="inline-flex items-center rounded-full bg-primary5 px-3 py-1 text-sm font-medium text-green1">
            Connected
          </span>
        </div>
      )}
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold text-cofeeGreyBlue11">
        Google Calendar
      </h3>
      <p className="text-sm text-grey">
        Connect your Google account to sync follow-ups and reminders.
      </p>
    </div>

    <div className="flex justify-end space-x-3">
      {isConnected && (
        <Button
          label="View Details"
          handleClick={onViewDetails}
          variant="transparent"
          size="small"
          className="text-primary hover:opacity-80"
        />
      )}
      <Button
        label={isConnected ? 'Disconnect' : 'Connect'}
        handleClick={handleConnection}
        variant={isConnected ? 'secondaryRed' : 'primary'}
        size="small"
        className={isConnected ? 'bg-white' : ''}
        disabled={isLoading}
        loading={isLoading}
      />
    </div>
  </div>
);

export default CalendarIntegrationContent;
